import { OutlineEffect } from 'three/examples/jsm/effects/OutlineEffect.js';
//import { AsciiEffect } from 'three/examples/jsm/effects/AsciiEffect.js';

var AvailableEffects = [
    { title: "Outline Effect", type: OutlineEffect, 
      settings: {
          "thickness": 0.003,
          "alpha": 1.0,
          "color": "#000000",
      },
      constructor: function (renderer) {
          return new OutlineEffect(renderer);
      },
    },
    //{ title: "Ascii Effect", type: AsciiEffect, 
    //    constructor: function (renderer) { 
    //        return new AsciiEffect(renderer, ' .:-+*=%@#', { invert: true });
    //    }
    //},
];

var EffectsNames = AvailableEffects.map(elm =>  elm.title);
//console.log("Effects Names:", EffectsNames);

export { AvailableEffects, EffectsNames };
